module.exports = __webpack_public_path__ + "static/media/6d94c45d2cafa385a8be5f3ea8.21b02487.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/6d94c45d2cafa385a8be5f3ea8.jpg
// module id = 42
// module chunks = 0